var Filters = angular.module('RessieApp.filters', [
  'RessieApp.filters.time',
  'RessieApp.filters.name',
  'RessieApp.filters.phone',
  'RessieApp.filters.card',
  'RessieApp.filters.array',
  'RessieApp.filters.object',
  'RessieApp.filters.string'
]);
